import Immutable from 'immutable';
import {
  FLAG_GETTING_BUS_ACTIVITY_HISTORY,
  GET_BUS_ACTIVITY_HISTORY,
  CLEAR_BUS_ACTIVITY_HISTORY,
} from '../../../actions/types/mechanical-maintenance';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_BUS_ACTIVITY_HISTORY:
      return state.setIn(['all', 'loading'], payload);
    case GET_BUS_ACTIVITY_HISTORY:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_BUS_ACTIVITY_HISTORY:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    default:
      return state;
  }
};
